import { Discount } from './discount';
import { PaymentMethodOption } from './payment-method-option';
import { Product } from './product';
import { SelfAttendanceData } from './self-attendance-data';
import {Messages} from "./messages";

export class Cart {

  // Cart Id
  // tslint:disable-next-line: variable-name
  _id: string;
  // SALE / UPGRADE / RETENTION
  type: string;
  // Caso seja necessário incluir o título algum dia
  title: string;
  // Descrição do carrinho (Exibir quando necessário)
  description: string;
  // Id do Vendedor ( SERASA Experian )
  sellerId: string;
  // Valor Total do Carrinho
  totalValue: number;
  // Valor Base do Carrinho (Sem Descontos)
  baseValue: number;
  // Valor cheio do produto
  productValue: number;
  // Forma de Pagamento do Carrinho
  paymentMethod: PaymentMethodOption;
  // Itens do Carrinho
  product: Product;
  // Descontos aplicados ao carrinho
  appliedDiscounts: Array<Discount> = [];
  //Cupom de Saldo Extra
  extraBalanceCoupon : Discount
  // AppliedCoupon
  couponIdentifier: string;
  // Se o carrinho possui um cupom válido aplicado
  hasValidAppliedCoupon: boolean;
  // Valor total de descontos
  discountedValue: number;
  // Dados de validação para descontos e venda
  validationData: any;
  // Termo de uso
  tdu: string;
  // BankBillet Discount Badge
  discountBadge: string;
  // Mensagens retornadas pelo ONE
  // messages: any;
  messages: Messages;

  trustConsultationData: any;
  // Dados adicionais
  allowSaleWithoutPayment: boolean;
  saleMessageInfo: string;
  invalidCS: boolean;

  // Dados de auto-atendimento
  // TODO - pensar numa modelagem melhor pra isso no futuro!
  selfAttendanceData: SelfAttendanceData;

  //valor calculado para o plano atual
  currentPlanItemsSum: number;

  constructor(cartData?: any) {
    if (cartData) {
      this._id = cartData._id;
      this.type = cartData.type;
      this.title = cartData.title;
      this.description = cartData.description;
      this.sellerId = cartData.sellerId;
      this.product = cartData.product;
      this.validationData = cartData.validationData;
      this.baseValue = cartData.baseValue;
      this.productValue = cartData.productValue;
      this.discountedValue = cartData.discountedValue;
      this.totalValue = cartData.totalValue;
      this.trustConsultationData = cartData.trustConsultationData;
      this.paymentMethod = cartData.paymentMethod;
      this.tdu = cartData.tdu||'';
      this.messages = cartData.messages || {};
      this.invalidCS = cartData.invalidCS || false;
      this.currentPlanItemsSum = cartData.currentPlanItemsSum || 0;

      if (cartData.validationData) {
        this.validationData = cartData.validationData;
      }
      if (cartData.appliedDiscounts && cartData.appliedDiscounts.length) {
        this.couponIdentifier = cartData.couponIdentifier;
        this.processDiscounts(cartData.appliedDiscounts);
        this.setSpecialRules();
      }

      if (cartData.selfAttendanceData) {
        this.selfAttendanceData = cartData.selfAttendanceData;
      }
    }
  }

  processDiscounts(appliedDiscounts) {
    if (appliedDiscounts.length) {
      appliedDiscounts.forEach(appliedDiscount => {
        const discount = new Discount(appliedDiscount);
        if (discount.identifier === 'BANKBILLETAUTO') {
          discount.title = 'Desconto no boleto';
          this.discountBadge = discount.deal;
        } else if (discount.identifier === 'UPGRADEAUTO') {
          discount.title = 'Desconto de migração';
        } else if (discount.trybuy && discount.trybuy.numberOfDays) {

          if (discount.automaticDiscount === true) {
            discount.title = 'Desconto de degustação automático';
          } else {
            discount.title = 'Desconto de degustação';
          }
      
          discount.deal = discount.trybuy.numberOfDays + ' Dias';
          this.hasValidAppliedCoupon = true;
        } else if (discount.automaticDiscount === true) {
          discount.title = 'Desconto automático';
        } else {
          // Se o desconto não enquadrou em nenhum dos casos acima,
          // mas é um desconto válido
          discount.title = 'Cupom aplicado';
          this.hasValidAppliedCoupon = true;
        }
        if (discount.type === 'EXTRA_BALANCE') {
          this.extraBalanceCoupon = discount;
        }
        this.appliedDiscounts.push(discount);
      });
    }
  }

  setSpecialRules() {
    if (this.appliedDiscounts && this.appliedDiscounts.length) {
      this.appliedDiscounts.forEach((discount) => {
        if (discount.allowSaleWithoutPayment && discount.saleMessageInfo) {
          this.saleMessageInfo = discount.saleMessageInfo;
          this.allowSaleWithoutPayment = discount.allowSaleWithoutPayment;
        }
      });
    }
  }

  getInstallmentsByIdentifier(identifier: string): any {
    if (this.paymentMethod.identifier === 'CREDIT_CARD') {
      let maxInstallmentsNumber = 1;
      let installmentValue = this.totalValue;
      this.paymentMethod.paymentConditionOptions.forEach((pmco) => {
        if (pmco.identifier === identifier) {
          maxInstallmentsNumber = pmco.installments;
          installmentValue = pmco.installmentValue;
        }
      });

      return {
        'installmentsNumber': maxInstallmentsNumber,
        'installmentValue': installmentValue,
      };
    } else {
      return null;
    }
  }

  hasPaymentMethodOptionWithIdentifier(identifier: string): boolean {
    let result = false;
    if (this.paymentMethod.identifier === 'CREDIT_CARD') {
      result = !!this.paymentMethod.paymentConditionOptions.find((pmo) => pmo.identifier === identifier);
    }

    return result;
  }
}
